export default __webpack_public_path__ + "static/fimir-b17eb85c22bd53bb8ced5791fecf5554.webp";